module.exports = __webpack_public_path__ + "img/twitter_logo.7259ed57.svg";